import baustein from "baustein";
import carouselMixin from "./mixins/carousel-mixin";


const componentName = "occasions-feed";

export default baustein.register(componentName, {
    componentName,
    mixins: [carouselMixin],
});
